import { useCallback } from 'react';
import { useParams } from 'react-router';
import { ShiftGeneratorTaskService } from 'src/api/ShiftGeneratorTaskService';
import { invalidateShiftGeneratorTaskData } from '@stores/shiftGeneratorTaskStore';

type DeleteTask = (taskId: string | undefined) => Promise<true>;

const useDeleteTask = (): { deleteTask: DeleteTask } => {
    const { departmentId } = useParams<{
        departmentId: string;
    }>();

    const deleteTask = useCallback<DeleteTask>(
        async (taskId) => {
            if (!departmentId || !taskId) {
                throw new Error(
                    'useDeleteTask requires a departmentId and taskId',
                );
            }

            const isDeleted = await ShiftGeneratorTaskService.deleteTask(
                departmentId,
                taskId,
            );

            invalidateShiftGeneratorTaskData();

            return isDeleted;
        },
        [departmentId],
    );

    return { deleteTask };
};

export default useDeleteTask;
